import { useParams } from "react-router-dom";


const ProductDetailScreen = (props) => {
    const { productName } = useParams();
    return <h1>ProductDetailScreen<br/> shown sku number {productName}</h1>;
  };
  
export default ProductDetailScreen;